import React from 'react';
import Agent from './Agent';
import Logo from './Logo';
import SocialIcons from './SocialIcons';

function LogoAgentContainer(props) {
    let logoAgentCode = null;
    let agentStyle = null;
    let agentNameColor = null;

    if (props.template === "CROSSBAR"
        || props.template === "CROSSBAR_LEFT"
        || props.template === "CROSSBAR_LEFT_FOOTER") {

        agentStyle = {
            backgroundColor: "rgb(116, 155, 219)",
            color: "#FFF",
            border: "1px solid rgb(204, 204, 204)",
            position: "relative",
            top: "40%",
            paddingLeft: "10px",
            paddingRight: "10px",
        }

        if (props.styles.agentBox) {
            agentStyle.backgroundColor = props.styles.agentBox.backgroundColor;
            agentStyle.color = props.styles.agentBox.color;
        }

        if (props.styles.agentName) {
            agentNameColor = {
                color: props.styles.agentName.color
            }
        }
    }

    if (props.logo || props.agent) {
        logoAgentCode = <div className="container mt-2 mb-2">
            <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-8">
                    <Logo logo={props.logo} dealerUrl={props.dealerUrl} />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-4">
                    <Agent agentNameColor={agentNameColor} styles={agentStyle} info={props.agent}
                        preview={props.preview} backgroundImageVal={props.backgroundImageVal} />
                </div>
            </div>
        </div>;
        if (props.template === "CROSSBAR") {
            logoAgentCode = <div className="container mt-2 mb-2">
                <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-8">
                        <Logo logo={props.logo} dealerUrl={props.dealerUrl} />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                        <SocialIcons shareurl={props.shareurl} dealerName={props.dealerName} template={props.template} />
                        <Agent styles={agentStyle} info={props.agent} template={props.template}
                            preview={props.preview} backgroundImageVal={props.backgroundImageVal} />
                    </div>
                </div>
            </div>
        } else if (props.template === "CROSSBAR_FOOTER") {
            logoAgentCode = <div className="container mt-2 mb-2">
                <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-8">
                        <Logo logo={props.logo} dealerUrl={props.dealerUrl} />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                        <Agent styles={agentStyle} info={props.agent} template={props.template}
                            preview={props.preview} backgroundImageVal={props.backgroundImageVal} />
                    </div>
                </div>
            </div>

        } else if (props.template === "SOCIALIZE" || props.template === "SOCIALIZE_FOOTER") {
            //code by anand
            logoAgentCode = < div className="container-fluid logo-bg">
                < div className="container mt-2">
                    <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-8">
                            <Logo logo={props.logo} dealerUrl={props.dealerUrl} />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-4">
                            <Agent styles={agentStyle} info={props.agent} shareurl={props.shareurl}
                                dealerName={props.dealerName} preview={props.preview} template={props.template} backgroundImageVal={props.backgroundImageVal} />
                        </div>
                    </div>
                </div>
            </div>;
            //-end
        } else if (props.template === "CROSSBAR_LEFT") {
            logoAgentCode = <div className="container mt-2 mb-2">
                <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-8">
                        <Logo logo={props.logo} dealerUrl={props.dealerUrl} />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                        <SocialIcons shareurl={props.shareurl} dealerName={props.dealerName} template={props.template} />
                    </div>
                </div>
            </div>;
        } else if (props.template === "CROSSBAR_LEFT_FOOTER") {
            agentStyle = {
                backgroundColor: "white",
                color: "#333",
                border: "1px solid transparent",
                position: "relative",
                top: "auto",
                paddingLeft: "10px",
                paddingRight: "10px",
            }

            if (props.styles.agentBox) {
                agentStyle.backgroundColor = props.styles.agentBox.backgroundColor;
                agentStyle.color = props.styles.agentBox.color;
            }

            if (props.styles.agentName) {
                agentNameColor = {
                    color: props.styles.agentName.color
                }
            }
            logoAgentCode = <div className="container mt-2 mb-2">
                <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-8">
                        <Logo logo={props.logo} dealerUrl={props.dealerUrl} />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                        <Agent styles={agentStyle} info={props.agent} shareurl={props.shareurl}
                            dealerName={props.dealerName} template={props.template} preview={props.preview} backgroundImageVal={props.backgroundImageVal} />
                    </div>
                </div>
            </div>;
        } else if (props.template === "SIMPLE_FLICKS") {
            logoAgentCode = null;
        } else if (props.template === "THEATER"
            || props.template === "THEATER_CONTACT"
            || props.template === "THEATER_CONTACT_FOOTER"
            || props.template === "THEATER_FOOTER"
            || props.template === "NEWSLETTER"
            || props.template === "NEWSLETTER_FOOTER"
            || props.template === "TABBED_THEATER"
            || props.template === "TABBED_THEATER_FOOTER"
            || props.template === "THEATER_360_FOOTER"
            || props.template === "THEATER_NO_SOCIAL") {
            let containerStyle = null;
            if (props.template === "TABBED_THEATER" || props.template === "TABBED_THEATER_FOOTER") {
                containerStyle = {
                    maxWidth: "960px"
                }
            }

            let newContainerStyle = null;

            let isMobile = false;
            if (/Android|webOS|iPhone|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent) ||
                (('ontouchstart' in window || navigator.maxTouchPoints > 0) &&
                    !(/iPad/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)))) {
                isMobile = true;
            }

            let theaterClass = '';

            if ((props.template === "THEATER_CONTACT" || "THEATER_CONTACT_FOOTER") && isMobile) {
                theaterClass = 'theater-contact';
                newContainerStyle = {
                    maxWidth: props.logo !== "" ? "50%" : "100%"
                }
            }
            let rowClass = `row ${theaterClass}`;

            logoAgentCode = <div className="container mt-2 mb-2" style={containerStyle}>
                <div className={rowClass}>
                    <div className="col-sm-6 col-md-6 col-lg-8" style={newContainerStyle}>
                        <Logo logo={props.logo} dealerUrl={props.dealerUrl} />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4" style={newContainerStyle}>
                        <Agent styles={agentStyle} info={props.agent} shareurl={props.shareurl}
                            dealerName={props.dealerName} dealerEmail={props.dealerEmail} video_fk={props.video_fk} template={props.template} preview={props.preview} backgroundImageVal={props.backgroundImageVal} />
                    </div>
                </div>
            </div>;
        } else if (props.template === "LP_LINKS_WITH_ICONS") {
            logoAgentCode = <div className="container mt-2 mb-2">
                <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-8">
                        <Logo logo={props.logo} dealerUrl={props.dealerUrl} />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                        <Agent agentNameColor={agentNameColor} styles={agentStyle} template={props.template} info={props.agent}
                            preview={props.preview} backgroundImageVal={props.backgroundImageVal} />
                    </div>
                </div>
            </div>;
        }
    }

    return (logoAgentCode);
}

export default LogoAgentContainer;


// WEBPACK FOOTER //
// ./src/components/LogoAgentContainer.js